import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';

@Component({
  selector: 'pr-media-file-icon',
  imports: [NgCommonModule],
  templateUrl: './media-file-icon.component.html',
  styleUrl: './media-file-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'h-full w-full block flex items-center justify-center' },
})
export class MediaFileIconComponent {
  extension = input.required<string>();

  iconPath = computed(() => {
    const extension = this.extension().toLowerCase();
    const iconsPath = '/assets/icons';

    switch (extension) {
      case 'csv':
        return `${iconsPath}/file-csv.svg`;
      case 'doc':
        return `${iconsPath}/file-doc.svg`;
      case 'docx':
        return `${iconsPath}/file-docx.svg`;
      case 'html':
        return `${iconsPath}/file-html.svg`;
      case 'pdf':
        return `${iconsPath}/file-pdf.svg`;
      case 'txt':
        return `${iconsPath}/file-txt.svg`;
      case 'xls':
        return `${iconsPath}/file-xls.svg`;
      case 'xlsx':
        return `${iconsPath}/file-xlsx.svg`;
      case 'zip':
        return `${iconsPath}/file-zip.svg`;
      default:
        return `${iconsPath}/file-blank.svg`;
    }
  });
}
